<template>
    <div>
        {{field}}
    </div>
</template>

<script>
export default {
    props:{
        field:[Object,String,Array,Number]
    }
}
</script>

<style>

</style>